import React from "react";
import "./index.css";
export default function Footer() {
  return (
    <div className="coder">
      <small>
        This project was coded by Hanna Vasylets and is{" "}
        <a
          href="https://github.com/hannavas2022/git-train2"
          target="_blank"
          rel="noreferrer"
        >
          Open-sourced on GitHub
        </a>
      </small>
    </div>
  );
}
